import { SinatraState } from '@rsos/sinatra';

export const USER_PROFILE: SinatraState['user']['profile'] = {
  attributes: {
    capstone: {
      audio_settings: {
        alerts: {
          volume: 0.6,
        },
        calls: {
          volume: 0.7,
        },
        sms: {
          volume: 0.7,
        },
        tt911: {
          volume: 0.7,
        },
      },
      call_taker_mode_settings: {
        is_enabled: false,
        workstation_position: '',
      },
      third_party_domains_check: {
        global_settings: {
          check_limit: 1,
          expiration_days: 30,
        },
        third_party_domains: {
          'https://google.com': {
            history: [],
          },
          'https://twilio.com': {
            history: [],
          },
        },
      },
    },
  },
  date_joined: '2020-10-06T22:12:35.129800',
  email: 'jsmith+alerts_dev_rsp@rapidsos.com',
  email_confirmed: true,
  first_name: 'John',
  id: '357',
  last_active_session: '2024-01-17T18:30:41.238454',
  last_name: 'Smith',
  organizations: [
    {
      attributes: {
        capstone: {
          alert_toasts: {
            alert_types: {},
          },
          audio_settings: {
            alerts: {
              repeat: true,
              sound_on: true,
              tone: 'bouyantKettle',
            },
            calls: {
              sound_on: true,
              tone: 'calypsoAlt',
            },
            sms: {
              sound_on: true,
              tone: 'approvalVibes',
              follow_up: {
                active_participants: {
                  sound_on: true,
                  tone: 'tripleVibe',
                },
                everyone_else: {
                  sound_on: false,
                  tone: 'tripleVibe',
                },
              },
            },
            tt911: {
              repeat: true,
              repeat_times: 5,
              sound_on: true,
              tone: 'bouyantKettle',
            },
          },
        },
      },
      id: 45,
      name: 'Lucas-Dev-Delta',
      roles: [
        {
          application: 'capstone',
          avatar_bg_color: '#ff8b00',
          id: 132,
          name: 'Admin',
          permissions: [
            'MANAGE_USERS',
            'RAPIDSOSQA',
            'MANAGE_AGENCY_INFO',
            'MANAGE_SECURITY',
            'MANAGE_INTEGRATIONS',
            'MANAGE_DATA_SOURCES',
            'NSION_WEB_MAP',
            '_911_SECURE',
            'PUBLIC_SONAR_ORG',
            '_911_INFORM',
            'MANAGE_PEER_AGENCIES',
            'iar_layers',
            'SAFEZONE',
            'ARCHER',
            'AVIVE',
            'RESPONSE_EYE',
            'archer',
            'SXM',
            'WHAT3WORDS',
            'archer_nonprod',
            'AGENT_511',
            'CRG',
            'RIDE_SHARING',
            'MANAGE_RESPONDERS',
            'AXON',
            'EVERBRIDGE',
            'RESPONDER_WEB_APP',
            'MANAGE_SOUND',
            'MEDICALERT_UK',
            'MANAGE_ROLES',
            'PROFILE_INFO',
            'EMERGENCY_HEALTH_ASSOCIATION',
            'ESRI_MAP',
            'ALI_GEOCOMM',
            'ESTIMATED_FLOOR_LEVELS_GEOCOMM',
            'GIS_SERVICES',
            'SAFEGRAPH',
            'ALI_INDIGITAL',
            'MAP_MARKUP',
            'EAGLE_EYE',
            'GOOGLE',
            'GEOCOMM_WEB_MAP',
            'ALERTS',
            'MANAGE_ALERT_PARTNERS',
            'IRP_MAP_ENABLED',
            'GIS_SEARCH',
            'TEXT_FROM_911',
          ],
          permissions_full: [
            {
              description:
                'Users with this permission can add/remove users to/from their organization.',
              display_name: 'Manage Users',
              is_new: false,
              name: 'MANAGE_USERS',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description: 'Allows you to consume dynamic layer data.',
              display_name: 'RapidSOS QA Spatial Layers',
              is_new: false,
              name: 'RAPIDSOSQA',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Account identifying information for your agency including but not limited to Name, Address, Contact Information, and Jurisdictional Boundary File.',
              display_name: 'Agency Info',
              is_new: false,
              name: 'MANAGE_AGENCY_INFO',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'IP sourcing designation allows the administrator to deny access to users attempting to login outside of the designated IP addresses.',
              display_name: 'Security',
              is_new: false,
              name: 'MANAGE_SECURITY',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'Third-party vendor integration for delivery of RapidSOS location and supplemental data i.e CAD, Mapping, other applications.',
              display_name: 'Integration Management',
              is_new: false,
              name: 'MANAGE_INTEGRATIONS',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS supplemental data sources i.e medical information, panic buttons, car crash data, etc… available to the user base to assist in emergencies.',
              display_name: 'Data Sources',
              is_new: false,
              name: 'MANAGE_DATA_SOURCES',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal launches NSION. URL whitelisting required - see RapidSOS Support Portal for details.',
              display_name: 'NSION',
              is_new: false,
              name: 'NSION_WEB_MAP',
              rsp_rbac: false,
              whitelisting_required: true,
            },
            {
              description:
                'RapidSOS Portal may show building information such as building address, floor plans, and admin contact information from 911 Secure.',
              display_name: '911 Secure',
              is_new: false,
              name: '_911_SECURE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'PublicSonar uses AI to quickly and easily assists you with real-time insights from the Internet’s endless messages.',
              display_name: 'PublicSonar',
              is_new: false,
              name: 'PUBLIC_SONAR_ORG',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "RapidSOS Portal may show a link to access 911 Inform's Command Center.",
              display_name: '911 Inform',
              is_new: false,
              name: '_911_INFORM',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Mutual aid/neighboring agencies that wish to share live incident data with your agency.',
              display_name: 'Share and Chat',
              is_new: false,
              name: 'MANAGE_PEER_AGENCIES',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description: 'IamResponding Responders and Vehicles',
              display_name: 'IamResponding Responders and Vehicles',
              is_new: false,
              name: 'iar_layers',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show alerts from gunshot detection sensors, including location of gunshot and number of shots detected from SafeZone.',
              display_name: 'SafeZone',
              is_new: false,
              name: 'SAFEZONE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description: 'Archer',
              display_name: 'Archer',
              is_new: false,
              name: 'ARCHER',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show a button to notify AEDs and App Users of a suspected cardiac arrest for immediate response.',
              display_name: 'Avive AED Dispatch',
              is_new: false,
              name: 'AVIVE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show a link to send a text video link and begin on-scene live video and photo streaming via 911eye Emergency Streaming web application.',
              display_name: '911eye Emergency Streaming',
              is_new: false,
              name: 'RESPONSE_EYE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description: 'archer',
              display_name: 'archer',
              is_new: false,
              name: 'archer',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show connected car data from Sirius XM, including details for the vehicle, airbag deployment, seat occupancy, impact and subscriber.',
              display_name: 'SiriusXM',
              is_new: false,
              name: 'SXM',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description: 'What3words',
              display_name: 'What3words',
              is_new: false,
              name: 'WHAT3WORDS',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description: 'Dynamic layers provided by Archer',
              display_name: 'Archer Nonprod',
              is_new: false,
              name: 'archer_nonprod',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may display incoming text-to-911 messages and a link to access AGENT511’s TEXTBLUE web application that can be used to reply to a text-to-911 message or generate a new outbound text message with specified phone number (text-from-911). Specific features available within RapidSOS Portal and within TEXTBLUE (e.g. multimedia, streaming video, language translation, etc…) are subject to your ECC’s specific agreement with AGENT511',
              display_name: 'AGENT511',
              is_new: false,
              name: 'AGENT_511',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "RapidSOS Portal may show building information and a link to access CRG's resources.",
              display_name: 'Critical Response Group',
              is_new: false,
              name: 'CRG',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show car make, model, color and year in addition to pickup location and dropoff location of a ridesharing vehicle (e.g. Uber).',
              display_name: 'Ridesharing information',
              is_new: false,
              name: 'RIDE_SHARING',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "Automatically notify responders via SMS of a train derailment in your ECC's jurisdiction.",
              display_name: 'Responders',
              is_new: false,
              name: 'MANAGE_RESPONDERS',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description: 'Axon Connected Body Cameras',
              display_name: 'Axon Connected Body Cameras',
              is_new: false,
              name: 'AXON',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show Everbridge 911 Connect data about the person in emergency.',
              display_name: 'Everbridge 911 Connect',
              is_new: false,
              name: 'EVERBRIDGE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Users with this permission can edit sound settings for their organization.',
              display_name: 'Audible Settings',
              is_new: false,
              name: 'MANAGE_SOUND',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show information about the caller such as name, age, and medical conditions.',
              display_name: 'MedicAlert UK',
              is_new: false,
              name: 'MEDICALERT_UK',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'The specified configurations the administrator set up for the different users within the agency.',
              display_name: 'Roles',
              is_new: false,
              name: 'MANAGE_ROLES',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show information about the caller such as name, age, and medical conditions.',
              display_name: 'Medical profile information',
              is_new: false,
              name: 'PROFILE_INFO',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "RapidSOS Portal may show device user's profile, medical information, COVID-19-related information, and emergency contacts.  This profile data has been filled out by the user on emergencyprofile.org.",
              display_name: 'Emergency Health Profile Association',
              is_new: false,
              name: 'EMERGENCY_HEALTH_ASSOCIATION',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Enables Esri-based map experience. Required in order to leverage GIS Services within RapidSOS Premium.',
              display_name: 'Esri Map',
              is_new: false,
              name: 'ESRI_MAP',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Uses data from your agency’s ANI/ALI feed to incorporate all call types into your RapidSOS call queue and map.',
              display_name: 'ANI/ALI',
              is_new: false,
              name: 'ALI_GEOCOMM',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "RapidSOS can display vertical location data for a caller's estimated floor level, via GeoComm’s Vertical Location Service. Want more accurate z-axis data? Upgrade to",
              display_name: 'Estimated Floor Levels',
              is_new: false,
              name: 'ESTIMATED_FLOOR_LEVELS_GEOCOMM',
              rsp_rbac: false,
              whitelisting_required: true,
            },
            {
              description:
                'RapidSOS Portal may show Esri-based GIS Layers onto the map. Esri services include - Map service, geocode service, and feature services',
              display_name: 'GIS Services',
              is_new: false,
              name: 'GIS_SERVICES',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'safegraph safegraph safegraph safegraph safegraph safegraph safegraph safegraph',
              display_name: 'Safegraph',
              is_new: false,
              name: 'SAFEGRAPH',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "Uses data from your agency's ALI/LDB feed via INdigital to incorporate all call types into your RapidSOS call queue and map",
              display_name: 'ANI/ALI via INdigital',
              is_new: false,
              name: 'ALI_INDIGITAL',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description: 'Add your notations to the map on the fly',
              display_name: 'Map Markup',
              is_new: true,
              name: 'MAP_MARKUP',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show Eagle Eye cameras near location of incidents.',
              display_name: 'Eagle Eye',
              is_new: true,
              name: 'EAGLE_EYE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'RapidSOS Portal may show device language and, if applicable, car crash data from Google devices.',
              display_name: 'Google ADR',
              is_new: false,
              name: 'GOOGLE',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                "RapidSOS Portal may show a link to access GeoComm's Web Map application.",
              display_name: 'GeoComm Web Map',
              is_new: false,
              name: 'GEOCOMM_WEB_MAP',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Access to data driven primary requests for emergency services.',
              display_name: 'Alerts',
              is_new: false,
              name: 'ALERTS',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Allows for management partners that wish to share alerts with your agency.',
              display_name: 'Manage Alert Partners',
              is_new: false,
              name: 'MANAGE_ALERT_PARTNERS',
              rsp_rbac: true,
              whitelisting_required: false,
            },
            {
              description:
                'Configures if the user should see the map when RapidSOS Portal is rendered via an iRP integration.',
              display_name: 'Display Map',
              is_new: false,
              name: 'IRP_MAP_ENABLED',
              rsp_rbac: false,
              whitelisting_required: false,
            },
            {
              description:
                'Enables the ability to search for addresses, cross streets, and points of interest available via local GIS Services and/or Esri’s World Geocoder. Users must also have Esri Map data source enabled.',
              display_name: 'GIS Search',
              is_new: false,
              name: 'GIS_SEARCH',
              rsp_rbac: false,
              whitelisting_required: false,
            },
          ],
        },
      ],
    },
  ],
  talkjs_signature:
    'ac76076f9e9f1cc788b9f9d5686ec1248e0cb928a21a732b92472bcac490aee8',
};

export default USER_PROFILE;
